import React from "react";
import "./styles.css";

const GroupDCT = ({ description }) => {
    return (
        <div className="userTag dct">
            <p>{description ? description : "DCT"}</p>
        </div>
    );
};

export default GroupDCT;